import React, {useEffect, useState} from 'react';
import Navbar from "../Navbar/Navbar";
import classes from './Uav.module.scss';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {useNavigate} from "react-router-dom";


// import AW6 from '../Images/aw6.2.png';
// import AW15 from '../Images/aw15-2.png';
// import AW17 from '../Images/aw17-2.png';
// import AW21 from '../Images/aw21.png';
// import AW25.glb from '../Images/aw25.png';
// import AW29 from '../Images/aw29.png';
// import AWC1 from '../Images/awc1.png';
// import AWC2 from '../Images/awc2.png';


//
// import AW15mini from '../Images/AW15.svg';
// import AW6mini from '../Images/AW6mini.svg';
// import AW15smini from '../Images/AW15mini.svg';
// import AW17mini from '../Images/AW17mini.svg';
// import AW21mini from '../Images/AW21mini.svg';
// import AW25mini from '../Images/AW25mini.svg';
// import AW29mini from '../Images/AW29mini.svg';
// import PDF from "../Files/AW Catalogue For Print.pdf";


import Fotter from "../Fotter/Fotter";
import Twentynine from "../AW29/Twentynine";


const UAV2 = 'https://i.imgur.com/0hxVjY9.png';
const AW6 = 'https://i.imgur.com/oRUQzhm.png';
const AW15 = 'https://i.imgur.com/xpIvUPS.png';
const AW17 = 'https://i.imgur.com/5XtVVkR.png';
const AW21 = 'https://i.imgur.com/uEw3t1t.png';
const AW25 = 'https://i.imgur.com/bMHqHwC.png';
const AW29 = 'https://i.imgur.com/emNolMb.png';
const AWC1 = 'https://i.imgur.com/CgJpehu.png';
const AWC2 = 'https://i.imgur.com/U9PCkte.png';


const images = [UAV2, AW6, AW15, AW17, AW21, AW25, AW29];
const bgClasses = ['bg-one', 'bg-two', 'bg-three', 'bg-for', 'bg-five', 'bg-six', 'bg-seven'];

const responsive = {
    superLargeDesktop: {
        breakpoint: {max: 4000, min: 3000},
        items: 5
    },
    desktop: {
        breakpoint: {max: 3000, min: 1024},
        items: 3
    },
    tablet: {
        breakpoint: {max: 1024, min: 464},
        items: 2
    },
    mobile: {
        breakpoint: {max: 464, min: 0},
        items: 1
    }
};

// const miniImages = [
//     AW15mini, AW6mini, AW15smini, AW17mini, AW21mini, AW25mini, AW29mini
// ];

function Uav() {
    // const [index, setIndex] = useState(0);
    const navigate = useNavigate();

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setIndex(prev => (prev + 1) % images.length);
    //     }, 3000);
    //
    //     return () => clearInterval(interval);
    // }, []);
    //
    // const currentImage = images[index];
    // const currentBgClass = bgClasses[index];
    // // const currentMiniImage = miniImages[index];
    //
    const handleNavigateToAW5 = () => {
        navigate('/awfive');
    };


    const handleNavigateToAW6 = () => {
        navigate('/awsix');
    };

    const handleNavigateToAW15 = () => {
        navigate('/fivethen');
    };


    const handleNavigateToAW17 = () => {
        navigate('/seventheen');
    };
    const handleNavigateToAW21 = () => {
        navigate('/twentyone');
    };
    const handleNavigateToAW25 = () => {
        navigate('/twentyfive');
    };
    const handleNavigateToAW29 = () => {
        navigate('/twentynine');
    };

    const handleNavigateToAWC1 = () => {
        navigate('/Cone');
    };
    const handleNavigateToAWC2 = () => {
        navigate('/Ctwo');
    };

    // ${classes[currentBgClass]}
    return (
        <div className={classes['uav']}>

            <div className={`${classes['uav-section-one']} `}>
                <div className={`${classes['navbar-uav']}`}>
                    <Navbar/>
                </div>

                <div
                    className={classes['uav-image']}

                    style={{}}
                ></div>

                <div className={classes['uav-paragraphs']}>
                    <p>DESIGN AND MANUFACTURE OF UAV</p>
                    {/*<h1>UAV’s</h1>*/}
                </div>

                {/*<img*/}
                {/*    src={currentMiniImage}*/}
                {/*    alt={`Mini UAV ${index}`}*/}
                {/*    className={`${classes['mini-image']} ${classes['top-right']}`}*/}
                {/*/>*/}
                {/*<img*/}
                {/*    src={currentMiniImage}*/}
                {/*    alt={`Mini UAV ${index}`}*/}
                {/*    className={`${classes['mini-image']} ${classes['bottom-right']}`}*/}
                {/*/>*/}
            </div>

            <div className={classes['uav-paragraph']}>
                <p>
                    Two types of payload: high-definition photo camera or
                    video camera with gimball. The ability to launch by hand
                    and parachute landing allows to launch from almost any
                    terrain without additional equipment. Quick-detachable
                    wing and stabilizer, which allows to prepare the UAV for
                    launch in a matter of seconds and prevent possible
                    damage during landing.
                </p>
            </div>

            {/*<div className={classes['section']}>*/}
            {/*    <div className={classes['aw5-horizonal-image']}> </div>*/}
            {/*</div>*/}

            <div  className={classes['slider-section']}>
                <div onClick={handleNavigateToAW5} className={classes['aw-5-section']}>
                    <p>AW5</p>
                    <img src={UAV2} alt="AW5"/>
                    <button onClick={handleNavigateToAW5}>Read more</button>
                </div>

                <div onClick={handleNavigateToAW6} className={classes['aw-6-section']}>
                    <p>AW6</p>
                    <img src={AW6} alt="AW6"/>
                    <button onClick={handleNavigateToAW6}>Read more</button>
                </div>

                <div onClick={handleNavigateToAW15} className={classes['aw-5-section']}>
                    <p>AW15</p>
                    <img src={AW15} alt="AW15"/>
                    <button onClick={handleNavigateToAW15}>Read more</button>
                </div>

                <div onClick={handleNavigateToAW17} className={classes['aw-6-section']}>
                    <p>AW17</p>
                    <img src={AW17} alt="AW17"/>
                    <button onClick={handleNavigateToAW17}>Read more</button>
                </div>

                <div onClick={handleNavigateToAW21} className={classes['aw-5-section']}>
                    <p>AW21</p>
                    <img src={AW21} alt="AW21"/>
                    <button onClick={handleNavigateToAW21}>Read more</button>
                </div>

                <div onClick={handleNavigateToAW25} className={classes['aw-6-section']}>
                    <p>AW25</p>
                    <img src={AW25} alt="AW25"/>
                    <button onClick={handleNavigateToAW25}>Read more</button>
                </div>

                <div onClick={handleNavigateToAW29} className={classes['aw-5-section']}>
                    <p>AW29</p>
                    <img src={AW29} alt="AW29"/>
                    <button onClick={handleNavigateToAW29}>Read more</button>
                </div>
                <div  onClick={handleNavigateToAWC1} className={classes['aw-6-section']}>
                    <p>AWC1</p>
                    <img src={AWC1} alt="AW29"/>
                    <button onClick={handleNavigateToAWC1}>Read more</button>
                </div>
                <div onClick={handleNavigateToAWC2} className={classes['aw-5-section']}>
                    <p>AWC2</p>
                    <img src={AWC2} alt="AW29"/>
                    <button onClick={handleNavigateToAWC2}>Read more</button>
                </div>
            </div>

            <div className={classes['product-section']}>
                <span>PRODUCT CATALOG</span>
                <a
                    href='https://drive.google.com/uc?export=download&id=11SZMlv6odw22okzmdVmDAOmu_yOSLNjf'
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <button>Download</button>
                </a>
            </div>
            <Fotter/>
        </div>
    );
}

export default Uav;
